import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "3", x2: "21", y1: "22", y2: "22", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "6", x2: "6", y1: "18", y2: "11", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "10", x2: "10", y1: "18", y2: "11", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "14", x2: "14", y1: "18", y2: "11", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "18", x2: "18", y1: "18", y2: "11", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polygon, { points: "12 2 20 7 4 7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Landmark";
const Landmark = memo(themed(Icon));
export {
  Landmark
};
//# sourceMappingURL=landmark.js.map
